import coursesApi from '@/services/plataforma/courses';

export default {
  async getAllCourses({ commit }, {
    mainType,
    search,
    perPage,
    page,
    order,
    sortBy,
    categoryIds,
    periodId,
    isActive,
    onlyWithContent,
    startAt,
    endAt,
    showAcademicsWithoutDate,
    pagination = true,
    approvalFlowStatusId,
    syncTypeId
  }) {
    return coursesApi.getAllCourses({
      type: mainType,
      search,
      perPage,
      page,
      order,
      sortBy,
      categoryIds,
      periodId,
      isActive,
      onlyWithContent,
      startAt,
      endAt,
      showAcademicsWithoutDate,
      pagination,
      approvalFlowStatusId,
      syncTypeId
    })
      .then(response => {
        commit('SET_INSTITUTION_TEMPLATE_ID', response.data.institutionTemplateId);
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  async getCoursesToImport({ commit }, {
    originAcademicSyncTypeId,
    search,
    categoryIds,
    periodId,
    page,
    perPage,
    pagination = true,
    sortBy,
    order
  }) {
    return coursesApi.getCoursesToImport({
      search,
      perPage,
      page,
      order,
      sortBy,
      categoryIds,
      periodId,
      pagination,
      originAcademicSyncTypeId
    })

      .then(response => {
        commit('SET_INSTITUTION_TEMPLATE_ID', response.data.institutionTemplateId);
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  async createCourse({ commit }, course) {
    return coursesApi.createCourse(course)
      .then(response => {
        commit('SET_NEW_COURSE', response.data);
        return Promise.resolve(response.data);
      })
      .catch(error => Promise.reject(error.response.data.error));
  },
  async getCourseById(_, courseId) {
    return coursesApi.getCourseById(courseId)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(error => Promise.reject(error.response.data.error));
  },
  async editCourse(_, course) {
    return coursesApi.editCourse(course)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(error => Promise.reject(error.response.data.error));
  },
  async deleteCourse(_, id) {
    return coursesApi.deleteCourse(id)
      .then(() => Promise.resolve())
      .catch(error => Promise.reject(error.response.data.error));
  },
  async getEnrolledCourses({ commit }, { state, filter, period, page, limit, type, categories }) {
    return coursesApi.getEnrolledCourses(state, filter, period, page, limit, type, categories)
      .then((response) => {
        commit('SET_USER_PERMISSIONS', response.data.permissions);
        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetCoursesForCopyContent({ commit }, { limit, page, filter, order, type, academicMainId, onlyWithContent, categoryIds, periodId, notIncludeAcademicMainId, notIncludeAcademicMainIds = null }) {
    return coursesApi.getCoursesForCopyContent(limit, page, filter, order, type, academicMainId, onlyWithContent, categoryIds, periodId, notIncludeAcademicMainId, notIncludeAcademicMainIds)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetCoursesForBatchProcess(_, { params, file }) {
    return coursesApi.getCoursesForBatchProcess(params, file)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  getPermissionByCourse({ commit }, id) {
    return coursesApi.getPermissionByCourse(id)
      .then((response) => {
        commit('SET_USER_PERMISSIONS', response.data);
        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  async actionSendAvaliaIntegration({ commit }, academicMainId) {
    return coursesApi.sendAvaliaIntegration(academicMainId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  getCourseEnrolledRoles(_, id) {
    return coursesApi.getCourseEnrolledRoles(id)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetBatchesTopics(_, params) {
    return coursesApi.getBatchesTopics(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.error.message);
      });
  },
  actionAccessStudentMode({ commit }, { academicMainId }) {
    return coursesApi.accessStudentMode(academicMainId)
      .then(response => {
        this.$token.set(response.data.user.token);

        return Promise.resolve(response.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionLogoutStudentMode(_, academicMainId) {
    return coursesApi.logoutStudentMode(academicMainId)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.error);
      });
  }
};
